export const isEverySelected = <T>(keys: T[], selectedItems: Set<T>) =>
  keys.length > 0 && keys.every((key) => selectedItems.has(key));
